import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {InputButton} from '@emersya/mpa-components';

export interface IPlannerLayoutTileComponentConfiguration extends InputButton.Configuration {
	readonly iconURL: string;
};

export class PlannerLayoutTileComponent extends InputButton.Component {
	static override getInputEventSubType() {
		const parentClass = <typeof CM.Component>STD.object.getParentClassFromClass(this);
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button', {});
		}
		return parentClass.type;
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IPlannerLayoutTileComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM.classList.add('thick');
	};
};
export namespace NS {
	export const Component = PlannerLayoutTileComponent;
	export type Component = PlannerLayoutTileComponent;
	export type Configuration = IPlannerLayoutTileComponentConfiguration;
}
import manifestXMLSource from './PlannerLayoutOptionTile.xml';
import './PlannerLayoutOptionTile.scss';

CM.Manager.declare({
	id: 'viewer-planner-layout-optionTile',
	type: PlannerLayoutTileComponent,
	manifest: manifestXMLSource
});
